import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Send, Server } from 'lucide-react';
import { API } from '@/App';

export const EmailSenderCard = () => {
  const [info, setInfo] = useState(null);
  const [to, setTo] = useState('');
  const [sending, setSending] = useState(false);
  const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };

  useEffect(() => {
    axios.get(`${API}/admin/emails/sender`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((r) => setInfo(r.data))
      .catch(() => {});
  }, []);

  const send = async () => {
    setSending(true);
    try {
      const r = await axios.post(`${API}/admin/emails/test-send`, { recipient: to.trim() }, { headers });
      toast.success(`Sent via ${r.data.provider} to ${r.data.recipient}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Send failed');
    } finally { setSending(false); }
  };

  if (!info) return null;
  const onResend = info.provider === 'resend';

  return (
    <Card className="bg-white/5 border-cyan-500/30" data-testid="email-sender-card">
      <CardContent className="pt-4 pb-3">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-2">
            <Server className="w-4 h-4 text-cyan-400" />
            <h3 className="font-semibold text-gray-200">Sending service</h3>
            <span
              data-testid="email-provider-badge"
              className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                onResend ? 'bg-emerald-500/20 text-emerald-300' : 'bg-amber-500/20 text-amber-300'}`}
            >
              {onResend ? 'Resend' : 'SMTP (add RESEND_API_KEY to switch)'}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Input
              placeholder="Send a test email to…"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              className="w-56 bg-white/5 border-white/10 text-sm"
              data-testid="email-test-recipient"
            />
            <Button size="sm" disabled={sending || !to.includes('@')} onClick={send}
                    className="bg-cyan-600 hover:bg-cyan-700" data-testid="email-test-send-btn">
              <Send className="w-4 h-4 mr-1" /> {sending ? 'Sending…' : 'Send test'}
            </Button>
          </div>
        </div>
        <p className="text-xs text-gray-400 mt-2">
          From <span className="text-cyan-300">{info.from_name} &lt;{info.from_email}&gt;</span>
          {' · '}replies to <span className="text-cyan-300">{info.reply_to}</span>
        </p>
      </CardContent>
    </Card>
  );
};

export default EmailSenderCard;
